let details_popup = document.querySelector('.detail-popup');
let details_popup_inner = document.querySelector('.detail-content');
let detail_btn = document.querySelectorAll('.view_details');
const updateProductDetail = async (product_handle) => {
  let getData = await fetch(window.Shopify.routes.root +`products/${product_handle}?section_id=detail-product`,{ headers: {"Content-Type": "text/html"}});
  let data = await getData.text();
  const MarkUp = new DOMParser()
          .parseFromString(data, 'text/html')
          .querySelector('#shopify-section-detail-product').innerHTML;
  details_popup_inner.innerHTML = MarkUp;

  // active class changer
  let detailalltab = details_popup_inner.querySelectorAll('.detail-tab > li');
    if(detailalltab.length > 0){
        detailalltab.forEach(li=>{
            li.onclick = function(){
                let data_id = li.dataset.id;
                li.parentElement.querySelectorAll('li').forEach(singleli=>singleli.classList.remove('active'));
                details_popup_inner.querySelector('*[data-open="'+ data_id +'"]').parentElement.querySelectorAll('*[data-open]').forEach(open_item=>open_item.classList.remove('active'));
                details_popup_inner.querySelector('*[data-open="'+ data_id +'"]').classList.add('active');
                li.classList.add('active');
            }
       })
  }

  // season and episode changer
  let allselector = details_popup_inner.querySelectorAll('.tab-selector');
  if(allselector.length){
      allselector.forEach(selector=>{
          selector.addEventListener('change',function() {
              if(!selector.classList.contains('season_episode_select')){
                details_popup_inner.querySelector('.product_tab_detail > .active [data-changer="'+ selector.value +'"]').parentElement.querySelectorAll(':scope > [data-changer]').forEach(changer=> changer.classList.remove('active'));
                details_popup_inner.querySelector('.product_tab_detail > .active  [data-changer="'+ selector.value +'"]').classList.add('active');
              }else{
                let selected = details_popup_inner.querySelector('.product_tab_detail > .active select[data-changer="'+ selector.value +'"]');
                if(details_popup_inner.querySelector('.product_tab_detail > .active select[data-changer="'+ selector.value +'"]').value != ''){
                  details_popup_inner.querySelector('.no-result').classList.remove('active');
                  selected.parentElement.querySelectorAll(':scope > [data-changer]').forEach(changer=> changer.classList.remove('active'));
                  selected.value = selected.querySelector('option:first-child').value;
                  selected.classList.add('active');
                  details_popup_inner.querySelector('.product_tab_detail > .active .detail_changer[data-changer^="'+ selector.value +'"]').parentElement.querySelectorAll(':scope > [data-changer]').forEach(changer=> changer.classList.remove('active'));
                  details_popup_inner.querySelector('.product_tab_detail > .active .detail_changer[data-changer^="'+ selector.value +'"]').classList.add('active');
                }else{
                  details_popup_inner.querySelector('.no-result').classList.add('active');
                  selected.parentElement.querySelectorAll(':scope > [data-changer]').forEach(changer=> changer.classList.remove('active'));
                  selected.classList.add('active');
                  details_popup_inner.querySelector('.product_tab_detail > .active .detail_changer').parentElement.querySelectorAll(':scope > [data-changer]').forEach(changer=> changer.classList.remove('active'));
                }
              }
          })
      });
  }
}
if(detail_btn.length){
  detail_btn.forEach(btn=>{
    btn.onclick = function(){
      details_popup.classList.add('popup-open');
      if(details_popup.dataset.id != btn.dataset.handle){
        details_popup_inner.innerHTML = ''; 
        updateProductDetail(btn.dataset.handle)
      }
      details_popup.dataset.id = btn.dataset.handle;
    }
  });
}

document.addEventListener('click',function(event){
  if(details_popup_inner && details_popup.classList.contains('popup-open') ){
    if(!details_popup_inner.contains(event.target) && details_popup.contains(event.target) || event.target.classList.contains('popup-close')){
      details_popup.classList.remove('popup-open');
    }
  }
 
});




